import React from "react";
import { IconSearch } from "@tabler/icons-react";

const ZoneEmptyState: React.FC = () => (
  <div className="flex flex-col items-center justify-center px-6 py-12 text-center min-h-[60vh]">
    <div className="w-16 h-16 rounded-full bg-emerald-50 flex items-center justify-center mb-2 md:mb-5">
      <IconSearch size={28} className="text-emerald-500" />
    </div>
    <h3 className="text-lg font-bold text-gray-900 mb-1">Selecciona una zona</h3>
    <p className="text-sm text-gray-500">Haz clic en una zona del mapa para ver detalles de precios y tendencias</p>
  </div>
);

export default ZoneEmptyState;
